import React, { useState, useEffect } from 'react';
import './EditModal.css';

export default function EditModal({ title, value, onSave, onClose }) {
  const [text, setText] = useState('');

  useEffect(() => {
    setText(typeof value === 'string' ? value : JSON.stringify(value, null, 2));
  }, [value]);

  function handleSave() {
    try {
      onSave(JSON.parse(text));
    } catch {
      onSave(text);
    }
  }

  return (
    <div className="edit-modal-overlay" onClick={onClose}>
      <div className="edit-modal" onClick={e => e.stopPropagation()}>
        <div className="edit-modal__header">
          <h3>{title}</h3>
          <button className="edit-modal__close" onClick={onClose}>×</button>
        </div>
        <textarea
          className="edit-modal__textarea"
          value={text}
          onChange={e => setText(e.target.value)}
          rows={16}
          spellCheck={false}
        />
        <div className="edit-modal__footer">
          <button className="btn btn-outline-navy" onClick={onClose}>취소</button>
          <button className="btn btn-primary" onClick={handleSave}>저장</button>
        </div>
      </div>
    </div>
  );
}

export function SectionEditBtn({ onClick }) {
  return (
    <button className="section-edit-btn" onClick={onClick} title="편집">
      <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <path d="M11 4H4a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2v-7"/>
        <path d="M18.5 2.5a2.121 2.121 0 013 3L12 15l-4 1 1-4 9.5-9.5z"/>
      </svg>
      편집
    </button>
  );
}
